
import { IUnderlag } from '../../Queries/VerifikationQuery/VerifikationQuery';
import Documents, {
  IDocument,
  getDocumentUrl,
} from '../../../../../../../../../Components/Documents/Documents';

interface IProps {
  activeDbname: string;
  bokforingsDatum: string;
  verNr: number;
  underlag: IUnderlag[];
  title: string;
}

const VerifikationsUnderlag: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const documents = props.underlag.map<IDocument>((underlag, underlagIndex) => {
    return {
      url: getDocumentUrl(underlag.blobId ?? ''),
      extension: underlag.extension,
      fileName: `underlag_ver_${props.verNr}_${
        underlag.description?.replaceAll(' ', '_') ?? underlagIndex
      }`,
    };
  });

  return (
    <Documents
      documents={documents}
      imageFullscreenTitle={props.title}
      appendDownloadedDateToFileName
    />
  );
};

export default VerifikationsUnderlag;
